<script setup>
import { ref, useAnimatedHeader } from '#imports';

const props = defineProps({
  isHideFooter: { type: Boolean, default: false },
  isHeaderShown: { type: Boolean, default: false },
  isAnimatedHeader: { type: Boolean, default: false },
  isShadyHeader: { type: Boolean, default: false },
  isTransparentHeader: { type: Boolean, default: false },
  forceTransparentHeader: { type: Boolean, default: false },
  isHideDonationForm: { type: Boolean, default: false },
  isHideSubscriptionBlock: { type: Boolean, default: false },
  isShowOnlySocials: { type: Boolean, default: false },
  isPride: { type: Boolean, default: false },
});

const headerElement = ref();

if (props.isAnimatedHeader && !process.server) {
  useAnimatedHeader(headerElement);
}
</script>

<template>
  <div class="news-layout">
    <div
      v-if="isHeaderShown"
      ref="headerElement"
      class="default-layout__header"
    >
      <TheHeaderSpecial v-if="isPride" />
      <TheHeader
        v-if="!isPride"
        :force-transparent="forceTransparentHeader"
        :is-colored-logo="false"
        :is-shady="isShadyHeader"
        :is-transparent="isTransparentHeader"
      />
      <slot name="progress-bar" />
      <slot name="mobile-progress-bar" />
    </div>

    <div class="page">
      <slot name="page-header"></slot>
      <slot name="page-content"></slot>
    </div>

    <TheFooter
      v-if="!isHideFooter"
      :is-hide-donation-form="isHideDonationForm"
      :is-hide-subscription-block="isHideSubscriptionBlock"
      :is-show-only-socials="isShowOnlySocials"
    />
  </div>
</template>

<style lang="postcss" scoped>
.news-layout {
  position: relative;
  background: linear-gradient(
    180deg,
    #ffbadf 0%,
    var(--page-background-color) 35%
  );

  .page {
    max-width: 964px;
    margin: 30px auto 30px;
    position: relative;
    min-height: 100vh;

    @media (--tablet-vp) {
      padding: 0 10px;
    }

    &__more-button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    &__section {
      margin: 36px 0;
    }

    &__title {
      font-size: 24px;
      margin-bottom: 16px;
    }

    &__news-item {
      margin-bottom: 8px;
    }
  }

  &__header-card {
    position: relative;
    z-index: 1;
  }

  &__header {
    position: sticky;
    z-index: calc(var(--modal-z-index) - 1);
    top: 0;
    transition: var(--default-transition) top;
  }

  &__header--static {
    position: relative;
  }
}
</style>
